import type { FC } from "react";

import { Button } from "@alpacahq/ui/old";

import type { Relationship } from "../common/types";
import { getRelationshipInfo } from "./getRelationshipInfo";
import { RelationshipInfo } from "./RelationshipInfo";

export const LinkedAccountCard: FC<{
  relationship: Relationship;
  onVerifyClicked?: () => void;
  onUnlinkClicked?: () => void;
}> = ({ relationship, onVerifyClicked, onUnlinkClicked }) => (
  <div className="flex items-center justify-between border-gray-200 border-b py-3">
    <RelationshipInfo {...getRelationshipInfo(relationship)} />

    <div className="flex items-center justify-end">
      {!!onUnlinkClicked && (
        <Button variant="secondary" onClick={onUnlinkClicked} className="mr-2">
          Unlink
        </Button>
      )}
      {!!onVerifyClicked && <Button onClick={onVerifyClicked}>Verify</Button>}
    </div>
  </div>
);
